import { useEffect, useState } from "react";
import { toast } from "sonner";
import { AlertTriangle, RefreshCw, Download, Trash2, Loader2 } from "lucide-react";
import { Button } from "../ui/button";
import { useRecording, mmss } from "../../lib/recording";
import { getPendingAudio, deletePendingAudio } from "../../lib/audioStore";
import { formatDateSafe } from "../../lib/formatDate";

export const PendingAudioCard = ({ reportId, disabled }) => {
  const { pendingVersion, retryPending, transcribing, bumpPending } = useRecording();
  const [item, setItem] = useState(null);
  useEffect(() => { getPendingAudio(reportId).then(setItem).catch(() => setItem(null)); }, [reportId, pendingVersion]);
  if (!item) return null;
  const busy = transcribing === reportId;
  const download = () => {
    const url = URL.createObjectURL(item.blob);
    const a = document.createElement("a");
    a.href = url; a.download = `seance-${reportId}-${new Date(item.savedAt).toISOString().slice(0, 10)}.webm`; a.click();
    setTimeout(() => URL.revokeObjectURL(url), 5000);
  };
  const remove = async () => {
    if (!window.confirm("Supprimer définitivement cet audio de l'appareil ? Il ne pourra plus être transcrit.")) return;
    await deletePendingAudio(reportId); bumpPending(); toast.success("Audio supprimé de l'appareil");
  };
  const mb = (item.size / 1048576).toFixed(1);
  return (
    <div className="rounded-lg border border-amber-300 bg-amber-50 dark:bg-amber-950/30 p-3 space-y-2" data-testid="pending-audio-card">
      <p className="text-sm font-medium flex items-center gap-2"><AlertTriangle className="w-4 h-4 text-amber-600" /> Audio en attente de transcription</p>
      <p className="text-xs text-muted-foreground" data-testid="pending-audio-meta">Enregistré le {formatDateSafe(new Date(item.savedAt).toISOString(), { day: "numeric", month: "long", hour: "2-digit", minute: "2-digit" })} · {mb} Mo{item.meta?.durationSec ? ` · ${mmss(item.meta.durationSec)}` : ""} · conservé uniquement sur cet appareil et ce navigateur.</p>
      <div className="flex flex-wrap gap-2">
        <Button size="sm" onClick={() => retryPending(reportId)} disabled={busy || disabled} className="gap-1.5" data-testid="pending-audio-retry-btn">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <RefreshCw className="w-4 h-4" />} {busy ? "Transcription en cours…" : "Relancer la transcription"}</Button>
        <Button size="sm" variant="outline" onClick={download} className="gap-1.5" data-testid="pending-audio-download-btn"><Download className="w-4 h-4" /> Télécharger l'audio</Button>
        <Button size="sm" variant="ghost" onClick={remove} disabled={busy} className="gap-1.5 text-destructive" data-testid="pending-audio-delete-btn"><Trash2 className="w-4 h-4" /> Supprimer</Button>
      </div>
    </div>
  );
};
